module.exports = __webpack_public_path__ + "img/Adamant_Arrowhead.92f25cb4.png";